export const genderOptions = [
  { label: '남성', value: 'MAN' },
  { label: '여성', value: 'WOMAN' },
];

export const ageOptions = [
  { label: '10대', value: '10' },
  { label: '20대', value: '20' },
  { label: '30대', value: '30' },
  { label: '40대', value: '40' },
  { label: '50대', value: '50' },
];

export const priceOptions = [
  { label: '~3천원', value: '~3000' },
  { label: '3천원~5천원', value: '3000~5000' },
  { label: '5천원~1만원', value: '5000~10000' },
  { label: '1만원~3만원', value: '10000~30000' },
  { label: '3만원~5만원', value: '30000~50000' },
  { label: '5만원~', value: '50000~' },
];
